'use strict';

var types = require('../../lib/types');
var keyPair = require('./../keyPair');
var generate = require('./generate');
var query = require('./query');

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const issueDID = /* @__PURE__ */ __name(async (didInput) => {
  const { wellKnownDid, did } = await query.queryDidDocument({
    domain: didInput?.domain
  }) ?? {};
  if (wellKnownDid && wellKnownDid.id !== did) {
    throw new Error("Input domain mismatch: " + wellKnownDid.id + " !== " + did);
  }
  const keyId = generate.nextKeyId(wellKnownDid);
  const generatedKeyPair = await keyPair.generateKeyPair(didInput);
  let keyPairs = {
    id: `${did}#keys-${keyId}`,
    type: generatedKeyPair.type,
    controller: did
  };
  if (generatedKeyPair.type === types.VerificationType.Bls12381G2Key2020) {
    keyPairs = {
      ...keyPairs,
      seedBase58: generatedKeyPair?.seedBase58,
      privateKeyBase58: generatedKeyPair?.privateKeyBase58,
      publicKeyBase58: generatedKeyPair?.publicKeyBase58
    };
  }
  const generatedWellKnownDid = generate.generateWellKnownDid({
    wellKnown: wellKnownDid,
    newKeyPair: keyPairs
  });
  return {
    wellKnownDid: generatedWellKnownDid,
    didKeyPairs: keyPairs
  };
}, "issueDID");

exports.issueDID = issueDID;
